export default function ({ id, section, intent }) {
  return {
    type: 'ADD',
    id, section, intent,
  }
}